import _ from 'underscore';
import { i18nMap } from '@bingads-webui-campaign/report-shared';
import { Shared as reportSchema } from '@bingads-webui/report-ui-interface-preview';
import * as putil from '@bingads-webui-universal/primitive-utilities';
import { i18nFilterTitleMap } from './strings';

const categories = [
  {
    metrics: [
      'Clicks',
    ],
    prefix: 'PerformanceMetrics/',
  },
];

// const maxCheckboxValues = 7;

function localizeEnumValues(i18n, property, propertyKey) {
  const tuples = _.map(property.enum, (enumValue) => {
    const englishString = i18nMap.FilterEnum[propertyKey] ?
      i18nMap.FilterEnum[propertyKey][enumValue] :
      putil.get(reportSchema, `columns.${property.columnName}.enum.${property.enumToColumnEnum[enumValue]}`);
    const localizedString = englishString ? i18n.getString(englishString) : String(enumValue);

    return [enumValue, localizedString];
  });
  return _.object(tuples);
}

export function localizeTitle(i18n, key) {
  const englishString = i18nFilterTitleMap[key];
  let localizedString;
  if (englishString) {
    localizedString = i18n.getString(englishString);
  } else {
    throw new Error(`Missing localization for filter title ${key}`);
  }

  return localizedString;
}

export function getUpperDescription(i18n, propertyKey) {
  const propertyName = localizeTitle(i18n, propertyKey);
  return i18n.getString(_TL_('Type {{propertyName}} (separate with commas):'), { propertyName });
}


function getPropertyPath(key) {
  const category = _.find(categories, ({ metrics }) => _.contains(metrics, key));
  const prefix = _.result(category, 'prefix', '');

  return `${prefix}${key}`;
}

export function processProperty(
  rawProperty, rawKey, i18n,
  permissions
) {
  const property = {
    ...rawProperty,
    title: localizeTitle(i18n, rawKey),
    customColumn: rawKey,
    property: getPropertyPath(rawKey),
  };

  if (property.enum) {
    if (property.columnName === 'Language' && !permissions.IsAdsGlobalizationPhase1Enabled) {
      property.enum = _.without(property.enum, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
    }
    if (property.columnName === 'Language' && !permissions.IsAdsGlobalizationPhase2Enabled) {
      property.enum = _.without(property.enum, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic', 'Japanese');
    }
    const localizationMap = localizeEnumValues(i18n, property, rawKey);
    if (property.columnName === 'AdType' && permissions.IsMultiMediaAdsEnabled) {
      // When enable IsMultiMediaAdsEnabled, show text as "Responsive ad / Multimedia ad"
      localizationMap.ResponsiveAd = i18n.getString(_TL_('Responsive ad / Multimedia ad'));
    }

    property.enum = _.chain(property.enum)
      .sortBy(property.type === 'integer' ? _.identity : _.propertyOf(localizationMap))
      // CheckboxEditor requires enum value to be string
      // @bingads-webui/predicate-list-react/src/predicate-value-editors/checkbox-editor.js
      //   checked: PropTypes.arrayOf(PropTypes.string)
      .map(v => String(v))
      .value();
    // keys in property.localized must have the same order with property.enum
    property.localized = _.chain(property.enum)
      .map(enumValue => [`Enum.${rawKey}'${enumValue}'`, localizationMap[enumValue]])
      .object()
      .value();

    // if (property.enum.length > maxCheckboxValues) {
    //   // Enforce using selector
    //   // @bingads-webui/predicate-list/src/predicate-creator.es line 12
    //   property.type = 'id';
    //   property.name = property.title;
    //   property.addtionalParams = {
    //     dataSource: {
    //       get(dummy, query) {
    //         let result = [...property.enum];

    //         if (_.isString(query)) {
    //           const queryLowerCase = query.toLowerCase();

    //           result = _.filter(result, (enumValue) => {
    //             const enumLowerCase = property.localized[enumValue].toLowerCase();

    //             return enumLowerCase.includes(queryLowerCase);
    //           });
    //         }

    //         result = _.map(result, enumValue => ({
    //           Id: enumValue,
    //           Name: property.localized[enumValue],
    //         }));

    //         return result;
    //       },
    //       itemsDisplayLimit: Number.MAX_SAFE_INTEGER,
    //     },
    //     selectorOptions: {
    //       keyMap: {
    //         Selector_Filter_Placeholder: () => `${i18n.getString(_TL_('Select'))} ${property.title}`,
    //       },
    //     },
    //   };

    //   // name must be identical to key, see
    //   // @bingads-webui/predicate-list-react/src/predicate-value-editors/selector-editor.js
    //   //   line 102
    //   // @bingads-webui/predicate-list/src/viewmodel/predicate.es line 18
    //   property.name = rawKey;
    //   // bypass default value
    //   // @bingads-webui/viewmodel-schema/src/default-value.es
    //   property.nullable = true;
    //   // Stub for hummanrized-predicate
    //   // @bingads-webui/humanized-predicate/src/humanized-predicate.js
    //   property.addtionalParams.dataSource.getByIds = (ids) => {
    //     const result = _.map(ids, id => ({
    //       Id: id,
    //       Name: id,
    //     }));

    //     return Promise.resolve(result);
    //   };
    // } else {
    property.chooseType = 'checkbox';
    // Enforce filter-i18n to consume property.localized
    // @bingads-webui/filter-i18n/src/index.es line 91
    property.type = 'string';
    // }
  } else if (property.type === 'string') {
    if (property.property === 'Keywords' || property.property === 'GoalIds') {
      property.operators = ['eq'];
      property.maxLength = 1024;
      property.chooseType = 'textarea';
      property.customParameters = {
        lowerDescription: i18n.getString(_TL_('Maximum 1024 character limit')),
        upperDescription: getUpperDescription(i18n, rawKey),
      };
      if (property.property === 'GoalIds') {
        property.pattern = /^\d+(,\d+)*$/;
        property.customParameters.lowerDescription = [
          property.customParameters.lowerDescription,
          i18n.getString(_TL_('Type {{propertyName}} requires integer value'), { propertyName: localizeTitle(i18n, rawKey) }),
        ].join('. ');
      }
    }
    // otherwise leave it as it is.
  } else if (property.type === 'integer') {
    property.required = true;
    if (property.displayType === 'ID') {
      property.skipLocalization = true;
    }
  } else if (property.type === 'percent' || property.type === 'float') {
    if (property.type === 'percent') {
      property.isPercentValue = true;
      property.format = 'Percentage';
    }
    property.type = 'number';
    property.required = true;
  } else {
    // filter definition is invalid, omit
    return null;
  }

  return property;
}

export function filterSchemaProcessor(
  filterSchema, i18n,
  permissions, name,
  isAccountScope
) {
  // Remove the filter item included in rejected columns.
  const rejectedColumns = [];
  if (filterSchema.piloted) {
    filterSchema.piloted.forEach(({ columns, isAllowed }) => {
      if (!isAllowed(permissions, !isAccountScope)) {
        columns.forEach(column => rejectedColumns.push(column));
      }
    });
  }
  const readOnlyProperties = [];
  if (filterSchema.restrictedFilterColumns) {
    filterSchema.restrictedFilterColumns.forEach(({ columns, isAllowed }) => {
      if (!isAllowed(permissions, !isAccountScope)) {
        columns.forEach(column => readOnlyProperties.push(column));
      }
    });
  }
  const properties = _.chain(filterSchema.properties)
    .pairs()
    .map(([key, property]) => [key, processProperty(
      property,
      key, i18n, permissions
    )])
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    .reject(([key, property]) => !property || rejectedColumns.includes(key))
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    .sortBy(([key, property]) => property.title)
    .object()
    .value();

  return {
    ...filterSchema,
    properties,
    name,
    readOnlyProperties,
  };
}
